import React, { Component } from 'react'

export default class index extends Component {
    render() {
        return (
            <div className="dwt">
                <div className="dwt-wrapper">
                    <div>
                    <div className="dwt-header">
                    <h2>Donate with
                        <br/>
                        trust
                    </h2>
                    <div className="dwt-bar"></div>
                    </div>
                    <p>Through our robust due diligence framework like <a href="/giveassured" target="_blank" style={{color: '#ff5050'}}>GiveAssured</a> and <a href=""  style={{color: '#ff5050'}}>GiveCompliant</a>, we ensure that critical checks are done for all nonprofit partners and their projects to assure your donations do what it is supposed to - change lives. </p>
                    </div>
                </div>
                <div className="box-outer-container">
                    <div className="box-wrapper first-tile">
                    <div className="box box-wrapper-b1">
                        <h2>1.7 M+</h2>
                        <p>Donors have contributed to causes</p>
                    </div>
                    <div className="box box-wrapper-b2">
                        <h2>1200 Cr+</h2>
                        <p>Raised for nonprofits</p>
                    </div>
                    </div>
                    <div className="box-wrapper second-tile">
                    <div className="box box-wrapper-b2">
                        <h2>200+</h2>
                        <p>Trusted by corporation and brands</p>
                    </div>
                    <div className="box box-wrapper-b1">
                        <h2>10 M</h2>
                        <p>Lives impacted</p>
                    </div>
                    </div>
                </div>
            </div>
        )
    }
}

